export default __webpack_public_path__ + "static/media/minusOn.9379e212.svg";